import userRoles from '@/utils/constants/userRoles';
import { tapRequestStatusesEnum } from '../_types';

export const UTA_MANAGEMENT_ACTIONS_ENUM = {
  save: 'save',
  submit: 'submit',
  print: 'print',
  continue: 'continue',
};

/**
 * El orden debe coincidir con el orden de los tabs.
 */
export const UTA_MANAGEMENT_TABS_ENUM = {
  'Analisis Escuela': 0,
  'Analisis Facilitador Docente': 1,
  'Consulta Director CSEE': 2,
  'Analisis Nivel Central': 3,
  'Analisis del SAEE': 4,
  'Historial de Enmiendas': 5,
};

/**
 * Las secciones que están mapeadas coinciden con los statusReasonTypes.
 */
export const UTA_MANAGEMENT_SECTION_ENUM = {
  'Proceso Prediscusión': 'Proceso Prediscusión',
  'Descripción Funcionamiento Estudiante': 'DescriptionEducationalFunctioning', // mapped
  'Acomodos Razonables Provistos': 'ReasonableAccommodationProvided', // mapped
  'Rezago Idioma Español': 'LagSpanishLanguage', // mapped
  'Problemas Conductuales': 'BehavioralProblems', // mapped
  'Servicios Provistos': 'ServicesProvided', // mapped
  'Alternativa Ubicación': 'RecommendedLocationAlternative', // mapped
  'Propósito Consulta': 'Propósito Consulta',
  Documentos: 'ConsultationDocuments', // mapped
  'Funcionarios Solicitan': 'Funcionarios Solicitan',
  'Terminos y Responsabilidades': 'Terminos y Responsabilidades',
  Consultas: 'PurposeConsultation',
  'Coordinar Reunion ORE Escuela': 'Coordinar Reunion ORE Escuela',
  'Coordinar Reunion ORE COMPU': 'Coordinar Reunion ORE COMPU',
  'Recomendar Reunion COMPU': 'Recomendar Reunion COMPU',
  'Búsqueda Localizaciones Disponibles': 'Búsqueda Localizaciones Disponibles',
  'Referir Consulta Director CSEE': 'Referir Consulta Director CSEE',
  'Búsqueda Localizaciones Disponibles Otra Region':
    'Búsqueda Localizaciones Disponibles Otra Region',
  'Crear Alternativa Ubicación': 'Crear Alternativa Ubicación',
  'Referir a la Secretaría Asociada de Educación Especial':
    'Referir a la Secretaría Asociada de Educación Especial',
  'Traslado Estudiante': 'Traslado Estudiante',
  'Búsqueda Localizacion Disponible': 'Búsqueda Localizacion Disponible',
};

export const UTA_MANAGEMENT_TABS_SECTIONS_CONFIG = {
  [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: [
    UTA_MANAGEMENT_SECTION_ENUM['Proceso Prediscusión'],
    UTA_MANAGEMENT_SECTION_ENUM['Descripción Funcionamiento Estudiante'],
    UTA_MANAGEMENT_SECTION_ENUM['Acomodos Razonables Provistos'],
    UTA_MANAGEMENT_SECTION_ENUM['Rezago Idioma Español'],
    UTA_MANAGEMENT_SECTION_ENUM['Problemas Conductuales'],
    UTA_MANAGEMENT_SECTION_ENUM['Servicios Provistos'],
    UTA_MANAGEMENT_SECTION_ENUM['Alternativa Ubicación'],
    UTA_MANAGEMENT_SECTION_ENUM['Propósito Consulta'],
    UTA_MANAGEMENT_SECTION_ENUM.Documentos,
    UTA_MANAGEMENT_SECTION_ENUM['Funcionarios Solicitan'],
    UTA_MANAGEMENT_SECTION_ENUM['Terminos y Responsabilidades'],
  ],

  [UTA_MANAGEMENT_TABS_ENUM['Analisis Facilitador Docente']]: [
    UTA_MANAGEMENT_SECTION_ENUM.Consultas,
    UTA_MANAGEMENT_SECTION_ENUM['Coordinar Reunion ORE Escuela'],
    UTA_MANAGEMENT_SECTION_ENUM['Coordinar Reunion ORE COMPU'],
    UTA_MANAGEMENT_SECTION_ENUM['Recomendar Reunion COMPU'],
    UTA_MANAGEMENT_SECTION_ENUM['Búsqueda Localizaciones Disponibles'],
    UTA_MANAGEMENT_SECTION_ENUM['Referir Consulta Director CSEE'],
    UTA_MANAGEMENT_SECTION_ENUM.Documentos,
    UTA_MANAGEMENT_SECTION_ENUM['Funcionarios Solicitan'],
  ],

  [UTA_MANAGEMENT_TABS_ENUM['Consulta Director CSEE']]: [
    UTA_MANAGEMENT_SECTION_ENUM.Consultas,
    UTA_MANAGEMENT_SECTION_ENUM['Recomendar Reunion COMPU'],
    UTA_MANAGEMENT_SECTION_ENUM['Búsqueda Localizaciones Disponibles'],
    UTA_MANAGEMENT_SECTION_ENUM[
      'Búsqueda Localizaciones Disponibles Otra Region'
    ],
    UTA_MANAGEMENT_SECTION_ENUM['Crear Alternativa Ubicación'],
    UTA_MANAGEMENT_SECTION_ENUM[
      'Referir a la Secretaría Asociada de Educación Especial'
    ],
    UTA_MANAGEMENT_SECTION_ENUM.Documentos,
    UTA_MANAGEMENT_SECTION_ENUM['Funcionarios Solicitan'],
  ],
  [UTA_MANAGEMENT_TABS_ENUM['Analisis Nivel Central']]: [
    UTA_MANAGEMENT_SECTION_ENUM.Consultas,
    UTA_MANAGEMENT_SECTION_ENUM['Recomendar Reunion COMPU'],
    UTA_MANAGEMENT_SECTION_ENUM['Búsqueda Localizacion Disponible'],
    UTA_MANAGEMENT_SECTION_ENUM.Documentos,
    UTA_MANAGEMENT_SECTION_ENUM['Traslado Estudiante'],
    UTA_MANAGEMENT_SECTION_ENUM['Funcionarios Solicitan'],
  ],
  [UTA_MANAGEMENT_TABS_ENUM['Analisis del SAEE']]: [
    UTA_MANAGEMENT_SECTION_ENUM.Documentos,
    UTA_MANAGEMENT_SECTION_ENUM['Funcionarios Solicitan'],
  ],
};

const ROLES_ENUM = {
  'Director Centro': userRoles.directorCentro,
  'Director Escolar': userRoles.director,
  'Facilitador Distrito': userRoles.facilitadorDistrito,
  'Facilitador Municipio': userRoles.facilitadorMunicipios,
  Facilitador: userRoles.facilitador,
  Técnico: userRoles.tecnico,
};

export const UTA_MANAGEMENT_REQUEST_TYPE = {
  NUEVO: 1,
  RENOVACION: 2,
  QUERELLA: 3,
};

const statusConfig = {
  activeSections: [],
  readonly: undefined,
  showActions: [],
  showStatusCard: undefined,
  showStatusTargetDropdown: undefined,
  statusCardReadonly: undefined,
  statusCardForm: undefined,
  statusTargetValidate: [],
  statusTargetOnlyActiveSections: undefined,
  tabInvisibleRoles: [],
};

const tabbedStatusConfig = {
  ...statusConfig,
  activeTab: UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela'],
  tabs: {},
};

const generateStatusConfig = (config = statusConfig) => ({
  ...statusConfig,
  ...config,
});

const generateTabStatusConfig = (config = tabbedStatusConfig) => {
  const _config = { ...tabbedStatusConfig, ...config };
  return { ..._config, showTabs: Object.keys(_config.tabs).map((x) => +x) };
};

const generateStatusModdedConfig = (
  { request, management } = {
    request: statusConfig,
    management: tabbedStatusConfig,
  }
) => ({
  request: generateTabStatusConfig({
    tabs: {
      [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig(
        request
      ),
      [UTA_MANAGEMENT_TABS_ENUM[
        'Historial de Enmiendas'
      ]]: generateStatusConfig({
        readonly: true,
      }),
    },
  }),
  management: generateTabStatusConfig(management),
});

/**
 * Maneja toda la configuracion de los status
 */
export const TAP_REQUEST_STATUSES_CONFIG = {
  // null
  NONE: generateStatusModdedConfig({
    request: {
      readonly: false,
      showActions: [UTA_MANAGEMENT_ACTIONS_ENUM.continue],
    },
  }),
  // 1
  [tapRequestStatusesEnum['Nuevo']]: generateStatusModdedConfig({
    request: {
      showActions: [
        UTA_MANAGEMENT_ACTIONS_ENUM.save,
        UTA_MANAGEMENT_ACTIONS_ENUM.submit,
      ],
    },
    management: {
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 2
  [tapRequestStatusesEnum['Sometido']]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
          showStatusTargetDropdown: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 3
  [tapRequestStatusesEnum['Proceso de Consulta']]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      activeTab: UTA_MANAGEMENT_TABS_ENUM['Analisis Facilitador Docente'],
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({
          readonly: false,
          showActions: [UTA_MANAGEMENT_ACTIONS_ENUM.save],
          showStatusTargetDropdown: true,
          statusTargetValidate: [
            tapRequestStatusesEnum['Recomendado a Evaluación de CSEE'],
            tapRequestStatusesEnum['Pendiente Revision de Escuela'],
          ],
          statusTargetOnlyActiveSections: {
            [tapRequestStatusesEnum['Pendiente Revision de Escuela']]: [
              UTA_MANAGEMENT_SECTION_ENUM['Funcionarios Solicitan'],
              UTA_MANAGEMENT_SECTION_ENUM['Terminos y Responsabilidades'],
            ],
          },
          tabInvisibleRoles: [ROLES_ENUM['Director Escolar']],
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 4
  [tapRequestStatusesEnum['Devuelto a la Escuela']]: generateStatusModdedConfig(
    {
      request: {
        readonly: false,
        showStatusCard: true,
        statusCardReadonly: true,
        showActions: [
          UTA_MANAGEMENT_ACTIONS_ENUM.save,
          UTA_MANAGEMENT_ACTIONS_ENUM.submit,
        ],
        activeSections: [
          UTA_MANAGEMENT_SECTION_ENUM['Funcionarios Solicitan'],
          UTA_MANAGEMENT_SECTION_ENUM['Terminos y Responsabilidades'],
        ],
        statusTargetValidate: [tapRequestStatusesEnum.Sometido],
      },
      management: {
        tabs: {
          [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
            readonly: true,
            showStatusCard: true,
            statusCardReadonly: true,
          }),
          [UTA_MANAGEMENT_TABS_ENUM[
            'Historial de Enmiendas'
          ]]: generateStatusConfig({
            readonly: true,
          }),
          showActions: [UTA_MANAGEMENT_ACTIONS_ENUM.print],
        },
      },
    }
  ),
  // 5
  [tapRequestStatusesEnum[
    'Proceso de Análisis del CSEE'
  ]]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      activeTab: UTA_MANAGEMENT_TABS_ENUM['Consulta Director CSEE'],
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Consulta Director CSEE'
        ]]: generateStatusConfig({
          readonly: false,
          showActions: [UTA_MANAGEMENT_ACTIONS_ENUM.save],
          showStatusTargetDropdown: true,
          statusTargetValidate: [
            tapRequestStatusesEnum['Recomendado a Evaluación de Nivel Central'],
            tapRequestStatusesEnum['Pendiente Revision de Escuela'],
            tapRequestStatusesEnum['Devuelto al Facilitador Docente'],
          ],
          statusTargetOnlyActiveSections: {
            [tapRequestStatusesEnum['Pendiente Revision de Escuela']]: [
              UTA_MANAGEMENT_SECTION_ENUM['Funcionarios Solicitan'],
              UTA_MANAGEMENT_SECTION_ENUM['Terminos y Responsabilidades'],
            ],
            [tapRequestStatusesEnum['Devuelto al Facilitador Docente']]: [
              UTA_MANAGEMENT_SECTION_ENUM['Funcionarios Solicitan'],
            ],
          },
          tabInvisibleRoles: [
            ROLES_ENUM['Director Escolar'],
            ROLES_ENUM.Facilitador,
            ROLES_ENUM['Facilitador Distrito'],
            ROLES_ENUM['Facilitador Municipio'],
          ],
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 6
  [tapRequestStatusesEnum[
    'Devuelto al Facilitador Docente'
  ]]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      activeTab: UTA_MANAGEMENT_TABS_ENUM['Analisis Facilitador Docente'],
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({
          readonly: false,
          showActions: [UTA_MANAGEMENT_ACTIONS_ENUM.save],
          showStatusCard: true,
          statusCardReadonly: true,
          showStatusTargetDropdown: true,
          statusTargetValidate: [
            tapRequestStatusesEnum['Recomendado a Evaluación de CSEE'],
          ],
          activeSections: [
            UTA_MANAGEMENT_SECTION_ENUM['Funcionarios Solicitan'],
          ],
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Consulta Director CSEE'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 7
  [tapRequestStatusesEnum[
    'Recomendado a Evaluación de CSEE'
  ]]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      activeTab: UTA_MANAGEMENT_TABS_ENUM['Analisis Facilitador Docente'],
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({
          readonly: true,
          showStatusTargetDropdown: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 9
  [tapRequestStatusesEnum[
    'Referido a Nivel Central'
  ]]: generateStatusModdedConfig(),
  // 10
  [tapRequestStatusesEnum[
    'Recomendado a Evaluación de Nivel Central'
  ]]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      activeTab: {
        [UTA_MANAGEMENT_REQUEST_TYPE.NUEVO]:
          UTA_MANAGEMENT_TABS_ENUM['Consulta Director CSEE'],
        [UTA_MANAGEMENT_REQUEST_TYPE.RENOVACION]:
          UTA_MANAGEMENT_TABS_ENUM['Consulta Director CSEE'],
        [UTA_MANAGEMENT_REQUEST_TYPE.QUERELLA]:
          UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela'],
      },
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
          showStatusTargetDropdown: {
            [UTA_MANAGEMENT_REQUEST_TYPE.QUERELLA]: true,
          },
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Consulta Director CSEE'
        ]]: generateStatusConfig({
          readonly: true,
          showStatusTargetDropdown: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 11
  [tapRequestStatusesEnum[
    'Proceso de Análisis de Nivel Central'
  ]]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      activeTab: UTA_MANAGEMENT_TABS_ENUM['Analisis Nivel Central'],
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Consulta Director CSEE'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Nivel Central'
        ]]: generateStatusConfig({
          readonly: false,
          showActions: [UTA_MANAGEMENT_ACTIONS_ENUM.save],
          showStatusTargetDropdown: true,
          statusTargetValidate: [
            tapRequestStatusesEnum['Recomendado al(la) Secretario(a)'],
            tapRequestStatusesEnum['No Recomendado'],
            tapRequestStatusesEnum['Pendiente Revision de Escuela'],
            tapRequestStatusesEnum['Devuelto al Director de CSEE'],
          ],
          statusTargetOnlyActiveSections: {
            [tapRequestStatusesEnum['Pendiente Revision de Escuela']]: [
              UTA_MANAGEMENT_SECTION_ENUM['Funcionarios Solicitan'],
              UTA_MANAGEMENT_SECTION_ENUM['Terminos y Responsabilidades'],
            ],
            [tapRequestStatusesEnum['Devuelto al Director de CSEE']]: [
              UTA_MANAGEMENT_SECTION_ENUM['Funcionarios Solicitan'],
            ],
          },
          tabInvisibleRoles: [
            ROLES_ENUM['Director Centro'],
            ROLES_ENUM['Director Escolar'],
            ROLES_ENUM.Facilitador,
            ROLES_ENUM['Facilitador Distrito'],
            ROLES_ENUM['Facilitador Municipio'],
          ],
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 12
  [tapRequestStatusesEnum[
    'Devuelto al Director de CSEE'
  ]]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      activeTab: UTA_MANAGEMENT_TABS_ENUM['Consulta Director CSEE'],
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Consulta Director CSEE'
        ]]: generateStatusConfig({
          readonly: false,
          showActions: [UTA_MANAGEMENT_ACTIONS_ENUM.save],
          showStatusCard: true,
          showStatusTargetDropdown: true,
          statusCardReadonly: true,
          activeSections: [
            UTA_MANAGEMENT_SECTION_ENUM['Funcionarios Solicitan'],
          ],
          statusTargetValidate: [
            tapRequestStatusesEnum['Recomendado a Evaluación de Nivel Central'],
          ],
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Nivel Central'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 14
  [tapRequestStatusesEnum[
    'Devuelto a Nivel Central'
  ]]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      activeTab: UTA_MANAGEMENT_TABS_ENUM['Analisis Nivel Central'],
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Consulta Director CSEE'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Nivel Central'
        ]]: generateStatusConfig({
          readonly: false,
          showActions: [UTA_MANAGEMENT_ACTIONS_ENUM.save],
          showStatusCard: true,
          showStatusTargetDropdown: true,
          statusCardReadonly: true,
          activeSections: [
            UTA_MANAGEMENT_SECTION_ENUM['Funcionarios Solicitan'],
          ],
          statusTargetValidate: [
            tapRequestStatusesEnum['Recomendado al(la) Secretario(a)'],
            tapRequestStatusesEnum['No Recomendado'],
          ],
        }),
        [UTA_MANAGEMENT_TABS_ENUM['Analisis del SAEE']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 15
  [tapRequestStatusesEnum['Aprobado']]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      activeTab: UTA_MANAGEMENT_TABS_ENUM['Analisis del SAEE'],
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Consulta Director CSEE'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Nivel Central'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM['Analisis del SAEE']]: generateStatusConfig({
          readonly: true,
          showStatusCard: true,
          statusCardReadonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 16
  [tapRequestStatusesEnum['No Aprobado']]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      activeTab: UTA_MANAGEMENT_TABS_ENUM['Analisis del SAEE'],
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Consulta Director CSEE'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Nivel Central'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM['Analisis del SAEE']]: generateStatusConfig({
          readonly: true,
          showStatusCard: true,
          statusCardReadonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 17
  [tapRequestStatusesEnum[
    'Pendiente Revision de Escuela'
  ]]: generateStatusModdedConfig({
    request: {
      readonly: true,
      showActions: [
        UTA_MANAGEMENT_ACTIONS_ENUM.save,
        UTA_MANAGEMENT_ACTIONS_ENUM.submit,
      ],
      showStatusCard: true,
      statusCardReadonly: true,
      activeSections: [
        UTA_MANAGEMENT_SECTION_ENUM['Funcionarios Solicitan'],
        UTA_MANAGEMENT_SECTION_ENUM['Terminos y Responsabilidades'],
      ],
      statusTargetValidate: [tapRequestStatusesEnum['Sometido Revisado']],
    },
    management: {
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
          activeSections: [
            UTA_MANAGEMENT_SECTION_ENUM['Proceso Prediscusión'],
            UTA_MANAGEMENT_SECTION_ENUM[
              'Descripción Funcionamiento Estudiante'
            ],
            UTA_MANAGEMENT_SECTION_ENUM['Acomodos Razonables Provistos'],
            UTA_MANAGEMENT_SECTION_ENUM['Rezago Idioma Español'],
            UTA_MANAGEMENT_SECTION_ENUM['Problemas Conductuales'],
            UTA_MANAGEMENT_SECTION_ENUM['Servicios Provistos'],
            UTA_MANAGEMENT_SECTION_ENUM['Alternativa Ubicación'],
            UTA_MANAGEMENT_SECTION_ENUM['Propósito Consulta'],
            UTA_MANAGEMENT_SECTION_ENUM['Documentos'],
            UTA_MANAGEMENT_SECTION_ENUM['Funcionarios Solicitan'],
            UTA_MANAGEMENT_SECTION_ENUM['Terminos y Responsabilidades'],
          ],
          showStatusCard: true,
          statusCardReadonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({
          readonly: true,
          showStatusCard: true,
          statusCardReadonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 18
  [tapRequestStatusesEnum['Sometido Revisado']]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
          showStatusTargetDropdown: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 19
  [tapRequestStatusesEnum[
    'Recomendado al(la) Secretario(a)'
  ]]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      activeTab: UTA_MANAGEMENT_TABS_ENUM['Analisis Nivel Central'],
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Consulta Director CSEE'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Nivel Central'
        ]]: generateStatusConfig({
          readonly: true,
          showStatusTargetDropdown: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 20
  [tapRequestStatusesEnum['No Recomendado']]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      activeTab: UTA_MANAGEMENT_TABS_ENUM['Analisis Nivel Central'],
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Consulta Director CSEE'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Nivel Central'
        ]]: generateStatusConfig({
          readonly: true,
          showStatusTargetDropdown: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 21
  [tapRequestStatusesEnum['Notificado']]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      activeTab: UTA_MANAGEMENT_TABS_ENUM['Analisis del SAEE'],
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({ readonly: true }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Consulta Director CSEE'
        ]]: generateStatusConfig({ readonly: true }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Nivel Central'
        ]]: generateStatusConfig({ readonly: true }),
        [UTA_MANAGEMENT_TABS_ENUM['Analisis del SAEE']]: generateStatusConfig({
          readonly: true,
          showStatusCard: true,
          statusCardReadonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 22
  [tapRequestStatusesEnum[
    'Proceso de Análisis del(la) Secretario(a)'
  ]]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      activeTab: UTA_MANAGEMENT_TABS_ENUM['Analisis del SAEE'],
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({ readonly: true }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Consulta Director CSEE'
        ]]: generateStatusConfig({ readonly: true }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Nivel Central'
        ]]: generateStatusConfig({ readonly: true }),
        [UTA_MANAGEMENT_TABS_ENUM['Analisis del SAEE']]: generateStatusConfig({
          readonly: false,
          showActions: [UTA_MANAGEMENT_ACTIONS_ENUM.save],
          showStatusTargetDropdown: true,
          statusTargetValidate: [
            tapRequestStatusesEnum.Aprobado,
            tapRequestStatusesEnum['No Aprobado'],
            tapRequestStatusesEnum['Pendiente Revision de Escuela'],
            tapRequestStatusesEnum['Devuelto a Nivel Central'],
          ],
          statusTargetOnlyActiveSections: {
            [tapRequestStatusesEnum['Pendiente Revision de Escuela']]: [
              UTA_MANAGEMENT_SECTION_ENUM['Funcionarios Solicitan'],
              UTA_MANAGEMENT_SECTION_ENUM['Terminos y Responsabilidades'],
            ],
            [tapRequestStatusesEnum['Devuelto a Nivel Central']]: [
              UTA_MANAGEMENT_SECTION_ENUM['Funcionarios Solicitan'],
            ],
          },
          tabInvisibleRoles: [
            ROLES_ENUM['Director Centro'],
            ROLES_ENUM['Director Escolar'],
            ROLES_ENUM.Facilitador,
            ROLES_ENUM['Facilitador Distrito'],
            ROLES_ENUM['Facilitador Municipio'],
            ROLES_ENUM.Técnico,
          ],
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 23
  [tapRequestStatusesEnum['Asignado']]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      activeTab: UTA_MANAGEMENT_TABS_ENUM['Analisis del SAEE'],
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Consulta Director CSEE'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Nivel Central'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM['Analisis del SAEE']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 24
  [tapRequestStatusesEnum['Enmendado']]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      activeTab: UTA_MANAGEMENT_TABS_ENUM['Analisis Nivel Central'],
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Consulta Director CSEE'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Nivel Central'
        ]]: generateStatusConfig({
          readonly: true,
          showStatusTargetDropdown: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM['Analisis del SAEE']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 26
  [tapRequestStatusesEnum['Proceso de Enmienda']]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      activeTab: UTA_MANAGEMENT_TABS_ENUM['Analisis Nivel Central'],
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Consulta Director CSEE'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Nivel Central'
        ]]: generateStatusConfig({
          readonly: false,
          showStatusTargetDropdown: true,
          statusTargetValidate: [
            tapRequestStatusesEnum['Recomendado al(la) Secretario(a)'],
            tapRequestStatusesEnum['No Recomendado'],
            tapRequestStatusesEnum['Devuelto al Director de CSEE'],
            tapRequestStatusesEnum['Pendiente Revision de Escuela'],
          ],
        }),
        [UTA_MANAGEMENT_TABS_ENUM['Analisis del SAEE']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  [tapRequestStatusesEnum['NoVigenteBaja']]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Consulta Director CSEE'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Nivel Central'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM['Analisis del SAEE']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  [tapRequestStatusesEnum['NoVigenteEgreso']]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Consulta Director CSEE'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Nivel Central'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM['Analisis del SAEE']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
  // 29
  [tapRequestStatusesEnum['Denegado']]: generateStatusModdedConfig({
    request: { readonly: true },
    management: {
      activeTab: UTA_MANAGEMENT_TABS_ENUM['Analisis Nivel Central'],
      tabs: {
        [UTA_MANAGEMENT_TABS_ENUM['Analisis Escuela']]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Facilitador Docente'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Consulta Director CSEE'
        ]]: generateStatusConfig({
          readonly: true,
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Analisis Nivel Central'
        ]]: generateStatusConfig({
          readonly: true,
          showActions: [],
          showStatusTargetDropdown: true,
          statusTargetValidate: [
            tapRequestStatusesEnum['Recomendado al(la) Secretario(a)'],
            tapRequestStatusesEnum['No Recomendado'],
            tapRequestStatusesEnum['Pendiente Revision de Escuela'],
            tapRequestStatusesEnum['Devuelto al Director de CSEE'],
          ],
          statusTargetOnlyActiveSections: {
            [tapRequestStatusesEnum['Pendiente Revision de Escuela']]: [
              UTA_MANAGEMENT_SECTION_ENUM['Funcionarios Solicitan'],
              UTA_MANAGEMENT_SECTION_ENUM['Terminos y Responsabilidades'],
            ],
            [tapRequestStatusesEnum['Devuelto al Director de CSEE']]: [
              UTA_MANAGEMENT_SECTION_ENUM['Funcionarios Solicitan'],
            ],
          },
          tabInvisibleRoles: [
            ROLES_ENUM['Director Centro'],
            ROLES_ENUM['Director Escolar'],
            ROLES_ENUM.Facilitador,
            ROLES_ENUM['Facilitador Distrito'],
            ROLES_ENUM['Facilitador Municipio'],
          ],
        }),
        [UTA_MANAGEMENT_TABS_ENUM[
          'Historial de Enmiendas'
        ]]: generateStatusConfig({
          readonly: true,
        }),
      },
    },
  }),
};
